import { render, staticRenderFns } from "./GerarFatura.vue?vue&type=template&id=2f904452"
import script from "./GerarFatura.vue?vue&type=script&lang=js"
export * from "./GerarFatura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports